import { create } from 'zustand'
import { NoteCtrlMenuState } from './NoteCtrlMenuState'
import { Note } from '../../Data/HexMap/Note'
import { Coordinates } from '../../Util/Math/Coordinates'
export interface NoteCtrlMenuConfig{
    note:Note|null,
    coordinates:Coordinates
    noteHider:Function
}
export const useNoteCtrlMenuStore = create<NoteCtrlMenuState>()(
  (setter) => new NoteCtrlMenuState(setter)
)

export function useCtrlNote(){
    const note:Note|null = useNoteCtrlMenuStore((state:NoteCtrlMenuState)=>{
      return state.note
    }) 
    return note
}

export function useNoteCtrlMenuCoordinates(){
    const coordinates:Coordinates = useNoteCtrlMenuStore((state:NoteCtrlMenuState)=>{
      return state.coordinates
    }) 
    return coordinates
}
export function useNoteCtrlMenuSetMap(){
    const setMap:Function = useNoteCtrlMenuStore((state:NoteCtrlMenuState)=>{
      return state.setMap
    }) 
    return setMap
}
export function useNoteCtrlMenuIsOpen(){
    const open:boolean = useNoteCtrlMenuStore((state:NoteCtrlMenuState)=>{
      return state.isOpen
    }) 
    return open
}